import { useEffect, useId, useState } from 'react';
import { Tab } from '@headlessui/react';
import clsx from 'clsx';

import { Container } from "../atoms/Container";
import { DiamondIcon } from '../atoms/DiamondIcon';
import first from '../../assets/images/photos/SantaCataliba.jpg';
import second from '../../assets/images/photos/Playa.jpg';
const days = [
    {
        name: 'Sucursales',
        date: 'La Habana',
        dateTime: '2022-04-04',
        speakers: [
            {
                name: 'Aceña (Santa Catalina)',
                role: ' Santa Catalina 555 entre Mayía Rodríguez y Goicuria, 10 Octubre',
                image: first,
                href:"https://tienda.tecopos.com/acenna-santa-catalina"
            },
            {
                name: 'Aceña (19 y 48)',
                role: 'Calle 19 entre 48 y 50. Playa',
                image: second,
                href:"https://tienda.tecopos.com/acenna-playa"
            },          
        ],
    },  
]

function ImageClipPaths({ id }: any) {
    return (
        <svg aria-hidden="true" width={0} height={0}>
            <defs>
                <clipPath id={`${id}-0`} clipPathUnits="objectBoundingBox">
                    <path d="M0,0 h0.729 v0.129 h0.121 l-0.016,0.032 C0.815,0.198,0.843,0.243,0.885,0.243 H1 v0.757 H0.271 v-0.086 l-0.121,0.057 v-0.214 c0,-0.032,-0.026,-0.057,-0.057,-0.057 H0 V0" />
                </clipPath>
                <clipPath id={`${id}-1`} clipPathUnits="objectBoundingBox">
                    <path d="M1,1 H0.271 v-0.129 H0.15 l0.016,-0.032 C0.185,0.802,0.157,0.757,0.115,0.757 H0 V0 h0.729 v0.086 l0.121,-0.057 v0.214 c0,0.032,0.026,0.057,0.057,0.057 h0.093 v0.7" />
                </clipPath>
                <clipPath id={`${id}-2`} clipPathUnits="objectBoundingBox">
                    <path d="M1,0 H0.271 v0.129 H0.15 l0.016,0.032 C0.185,0.198,0.157,0.243,0.115,0.243 H0 v0.757 h0.729 v-0.086 l0.121,0.057 v-0.214 c0,-0.032,0.026,-0.057,0.057,-0.057 h0.093 V0" />
                </clipPath>
            </defs>
        </svg>
    )
}

export function GallerySection() {
    let id = useId()
    let [tabOrientation, setTabOrientation] = useState('horizontal')

    useEffect(() => {
        let lgMediaQuery = window.matchMedia('(min-width: 1024px)')

        function onMediaQueryChange({ matches }: any) {
            setTabOrientation(matches ? 'vertical' : 'horizontal')
        }

        onMediaQueryChange(lgMediaQuery)
        lgMediaQuery.addEventListener('change', onMediaQueryChange)

        return () => {
            lgMediaQuery.removeEventListener('change', onMediaQueryChange)
        }
    }, [])

    return (
        <section
            id="speakers"
            aria-labelledby="speakers-title"
            className="py-20 sm:py-32"
        >
            <ImageClipPaths id={id} />
            <Container>
                <div className="mx-auto max-w-2xl lg:mx-0">
                    <h2
                        id="speakers-title"
                        // style={{ color: "#b64e30" }}
                        className="font-display text-4xl text-red-700 dark:text-white font-medium tracking-tighter sm:text-5xl"
                    >
                        ¡Ven y disfruta
                        del sabor auténtico de Aceña! todos los días de 8:00 am - 8:00 pm.
                    </h2>
                    <p className="mt-4 font-display dark:text-white text-gray-900 text-xl tracking-tight">
                        "Entra en un mundo de sabor y aroma en nuestros locales de venta. Descubre la
                        fusión perfecta de lo antiguo y lo moderno de la panadería Aceña."
                    </p>
                </div>
                <Tab.Group
                    as="div"
                    className="mt-14 grid grid-cols-1 items-start gap-y-8 gap-x-8 sm:mt-16 sm:gap-y-16 lg:mt-24 lg:grid-cols-4"
                    vertical={tabOrientation === 'vertical'}
                >
                    <div className="relative -mx-4 flex overflow-x-auto pb-4 sm:mx-0 sm:block sm:overflow-visible sm:pb-0">
                        <div className="absolute bottom-12 top-4 left-0.5 hidden w-px bg-red-700 lg:block" />
                        <Tab.List className="grid auto-cols-auto grid-flow-col justify-start gap-x-8 gap-y-10 whitespace-nowrap px-4 sm:mx-auto sm:max-w-2xl sm:grid-cols-3 sm:px-0 sm:text-center lg:grid-flow-row lg:grid-cols-1 lg:text-left">

                            {({ selectedIndex }: any) =>
                                days.map((day, dayIndex) => (
                                    <div key={day.dateTime} className="relative lg:pl-8">
                                    
                                        <DiamondIcon

                                            className={clsx(
                                                'absolute top-[0.5625rem] left-[-1px] fill-red-800 hidden h-2 w-2 overflow-visible lg:block',
                                                dayIndex === selectedIndex
                                                    ? 'fill-red-700  stroke-red-700'
                                                    : 'fill-transparent stroke-red-700'
                                            )}
                                        />
                                        <div className="relative">
                                            <div
                                                className={clsx(
                                                    'font-mono text-sm',
                                                    dayIndex === selectedIndex
                                                        ? 'text-blue-600'
                                                        : 'text-slate-500'
                                                )}
                                            >
                                                <Tab style={{ color: "#b91c1c" }} className="[&:not(:focus-visible)]:focus:outline-none dark:text-white">
                                                    <span className="absolute inset-0 " />
                                                    {day.name}
                                                </Tab>
                                            </div>
                                            <time
                                                style={{ color: "#b91c1c" }}
                                                dateTime={day.dateTime}
                                                className="mt-1.5 block  text-2xl font-semibold tracking-tight"
                                            >
                                                {day.date}
                                            </time>
                                            </div>
                                           
                                    </div>
                                )) as any
                            }

                        </Tab.List>
                    </div>
                    <Tab.Panels className="lg:col-span-3">
                        {days.map((day) => (
                            <Tab.Panel
                                key={day.dateTime}
                                className="grid grid-cols-1 place-items-center gap-x-10 gap-y-10 sm:grid-cols-2 sm:gap-y-16 md:grid-cols-2 lg:grid-cols-3 [&:not(:focus-visible)]:focus:outline-none"
                                unmount={false}
                            >
                                
                                {day.speakers.map((speaker, speakerIndex) => (
                                    <div key={speakerIndex}>
                                        <a href={speaker.href}>
                                        <div className="group relative h-56 w-56 transform overflow-hidden rounded-3xl">
                                            <div
                                                className={clsx(
                                                    'absolute top-0 left-0 right-4 bottom-6 rounded-3xl border transition duration-300 group-hover:scale-95 xl:right-6',
                                                    [
                                                        'border-red-800',
                                                        'border-red-700',
                                                        'border-red-600',
                                                    ][speakerIndex % 3]
                                                )}
                                            />
                                            <div
                                                className="absolute rounded-xl overflow-hidden inset-0 bg-indigo-50"
                                                style={{ clipPath: `url(#${id}-${speakerIndex % 3})` }}
                                            >
                                                <img
                                                    className="absolute inset-0 h-60 w-60 object-cover transition duration-300 group-hover:scale-110"
                                                    src={speaker.image}
                                                    alt=""
                                                    sizes="(min-width: 1280px) 17.5rem, (min-width: 1024px) 25vw, (min-width: 768px) 33vw, (min-width: 640px) 50vw, 100vw"
                                                />
                                            </div>
                                        </div>
                                        <h3 className="mt-8 font-display text-xl font-bold tracking-tight dark:text-white text-slate-900">
                                            {speaker.name}
                                        </h3>
                                        <p className="mt-1 text-base tracking-tight dark:text-white text-slate-500">
                                            {speaker.role}
                                            </p>
                                            </a>
                                    </div>
                                ))}
                            </Tab.Panel>
                        ))}
                    </Tab.Panels>
                </Tab.Group>
            </Container>
        </section>
    )
}
